import { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { Anchor } from "../../Shared/Common/Anchor";
import { EUROPE_PAGE } from "../../../interfaces/Static/routing_paths";
import EqualityTable from "./_equality_table";
import { indexData } from "./_table_data";

const FranceGenderEqualityIndex: FC = () => {
  return (
    <div className="france-gender-equality-index">
      <Container>
        <Row>
          <Col xs={12}>
            <div className="breadcrumb-container">
              <Anchor href={EUROPE_PAGE}>Home</Anchor>
              <Anchor href="#">
                <FormattedMessage id="page.europe.france_gender_equality_index.title" />
              </Anchor>
            </div>
            <h1>
              <FormattedMessage
                id="page.europe.france_gender_equality_index"
                values={{ br: <br /> }}
              />
            </h1>

            {indexData.map((section, index) => (
              <EqualityTable
                key={section.titleId}
                section={section}
                isFirst={index === 0}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default FranceGenderEqualityIndex;
